import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import GlobalProgressBar from "./components/GlobalProgressBar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import TimelineSection from "./components/TimelineSection";
import CompetitionsGrid from "./components/CompetitionsGrid";
import GalleryPreview from "./components/GalleryPreview";
import CampusMap from "./components/CampusMap";
import Footer from "./components/Footer";
import SEO from "./components/SEO";
import TeamPage from "./pages/TeamPage";
import EventsPage from "./pages/EventsPage";
import EventDetailsPage from "./pages/EventDetailsPage";
import GalleryPage from './pages/GalleryPage';
import ClubsPage from './pages/ClubsPage';
import AboutPage from './pages/AboutPage';

const Home = () => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    'name': 'Ekatva 2026',
    'description': 'The Annual Techfest of Shri Mata Vaishno Devi University',
    'image': 'https://ekatva-fest.smvdu.ac.in/logo_ekatva.webp',
    'url': 'https://ekatva-fest.smvdu.ac.in',
    'organizer': {
      '@type': 'Organization',
      'name': 'SMVDU',
      'url': 'https://smvdu.ac.in'
    },
    'startDate': '2026-04-01',
    'endDate': '2026-04-05'
  };

  return (
    <div className="bg-[#050505] min-h-screen">
      <SEO 
        title="Ekatva 2026 | SMVDU Techfest"
        description="Ekatva 2026 - The Annual Techfest of Shri Mata Vaishno Devi University. Explore exciting competitions, events, and innovation hub."
        url="https://ekatva-fest.smvdu.ac.in/"
        type="Event"
        canonicalUrl="https://ekatva-fest.smvdu.ac.in/"
        structuredData={structuredData}
      />
      <GlobalProgressBar />
      <a
        href="https://smvdu.ac.in"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed top-5 left-4 md:top-7 md:left-6 z-[1300] flex items-center justify-center sm:justify-start gap-0 sm:gap-2 rounded-full p-2 sm:px-5 sm:py-3 border border-white/[0.1] bg-black/60 backdrop-blur-xl hover:bg-black/75 transition-colors"
        data-testid="smvdu-floating-link"
      >
        <img src="/smvdu_logo.webp" alt="SMVDU" loading="lazy" className="h-8 w-8 object-contain" />
        <span className="hidden sm:inline font-mono text-xs md:text-sm tracking-widest text-white/90">SMVDU</span>
      </a>
      <Navbar />
      <HeroSection />
      <AboutSection />
      <TimelineSection />
      <CompetitionsGrid />
      <GalleryPreview />
      <CampusMap />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/events/:eventId" element={<EventDetailsPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/clubs" element={<ClubsPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
